import Vue from 'vue';
import Router from 'vue-router';

import PPanel from '@/pages/p-panel';

import P404 from '@/pages/p-404';

import PageDashboard from '@/pages/PageDashboard';

import PagePresentationSettings from '@/pages/PagePresentationSettings';
import PPresentations from '@/pages/p-presentations';
import PEditor from '@/pages/p-editor';
import CEditorCharts from '@/components/p-editor/c-editor-charts';


import PRolePermission from '@/pages/p-role-permission';
import PUserform from '@/pages/p-userform';

import PStyleguide from '@/pages/p-styleguide';
import PTranslations from '@/pages/p-translations';
import PageGroup from '@/pages/PageGroup';
import PageGroupReset from '@/pages/PageGroupReset';

import PageTest from '@/pages/PageTest';
import PageSettings from '@/pages/PageSettings';


import PageUser from '@/pages/PageUser';
import PageUserOverview from '@/pages/PageUserOverview';

import PageChannel from '@/pages/PageChannel';
import PageMediaStore from '@/pages/PageMediaStore';

Vue.use(Router);

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '404',
			from: '*',
			component: P404
		},

		{
			path: '/panel',
			component: PPanel,
				children: [
				{
					path: '404',
					component: P404
				},

				{
					path: 'channel',
					component: PageChannel
				},

				{
					name: 'media_store',
					path: 'media_store',
					component: PageMediaStore
				},
				{
					name: 'test',
					path: 'test',
					component: PageTest
				},
				{
					name: 'settings',
					path: 'settings',
					component: PageSettings
				},

				{
					path: '',
					alias: 'home',
					component: PageDashboard
				},

				{
					name: 'styleguide',
					path: 'styleguide',
					component: PStyleguide
				},
				{
					name: 'translations',
					path: 'translations',
					component: PTranslations
				},
				{
					path: 'users',
					component: PageGroupReset,
					canReuse: false,
					children: [
						{
							name: 'user-list',
							path: ':role',
							component: PageUserOverview,
							props: true
						},
						{
							name: 'user-permissions',
							path: ':role/permissions',
							component: PRolePermission,
							props: true
						},
						{
							path: ':role/:uid',
							component: PageUser,
							props: true,
							children: [
								{
									name: 'user-edit',
									path: '',
									component: PUserform
								}
							]
						},
					]
				},

				{
					path: 'master-slides',
					component: PEditor,
					props: {
						master: true,
					},
					children: [
		    			{
		    				name: 'master-chart',
		    				path: ':chartid',
		    				props: true,
		    				component: CEditorCharts
		    			}
					]
				},
				{
					path: 'presentation',
					component: PageGroupReset,
					canReuse: false,
					children: [
						{
							name: 'presentation-list',
							path: '',
							component: PPresentations,
							canReuse: false,
						},
						{
							name: 'presentation-new',
							path: 'new',
							component: PagePresentationSettings,
							canReuse: false,
						},
						{
							name: 'presentation-settings',
							path: 'settings/:pid',
							component: PagePresentationSettings,
							canReuse: false,
							props: true,
						},
						{
							name: 'editor',
							path: 'edit/:pid',
							props: true,
							component: PEditor,
							children: [
			        			{
			        				name: 'presentation-chart',
			        				path: ':chartid',
			        				props: true,
			        				component: CEditorCharts
			        			}
			      			]
		      			}
					]
				},
				{
					path: '*',
					redirect: '404'
				},
			],
		}
	]
});



// WEBPACK FOOTER //
// ./src/router/index.js